export default __webpack_public_path__ + "static/media/info.68dc82c5.svg";